import CryptoJS from "crypto-js";

export const  handleEncryptData =(data)=>{

    const CRYPTKEY = 'e33b5c9c6c0998bc';
    const CRYPTIV = 'NcRfUjWnZr4u7x';

    const cryptkey = CryptoJS.enc.Utf8.parse(CRYPTKEY);
    const cryptiv = CryptoJS.enc.Utf8.parse(CRYPTIV);

    var encrypt = CryptoJS.AES.encrypt(JSON.stringify(data), cryptkey, {
        iv: cryptiv,
        mode:CryptoJS.mode.CTR,
    });
    const cipher = encrypt.toString();
 
    return { cipher };
}